import styled from "styled-components";

const Container = styled.div`
    color: red;
    text-align: center;
    margin-top: 10px
`

type ErrorMessageProps = {
    children: string
}

export const ErrorMessage = ({ children }: ErrorMessageProps) => {
    return <Container>{children}</Container>
}